export type StyleOptionsSwissVisibility = {
    textColor: true;
    titleColor: true;
    backgroundColor: true;
};
